const doc = [({"en":({"models":({"email":({"confirmable":({"is_already_used":"is already used"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;